export const environment = {
  production: true,
  token:'117FAD8D-D2EE-42DC-8CCE-097FC8DE148A',
};
